import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab', 'panel']

  switchTab(event) {
    const index = event.params.index

    this.tabTargets.forEach((tab, i) => {
      tab.classList.toggle('border-orange-500', i === index)
      tab.classList.toggle('text-slate-900', i === index)
      tab.classList.toggle('border-transparent', i !== index)
      tab.classList.toggle('text-slate-500', i !== index)
    })

    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle('hidden', i !== index)
    })
  }

  send(event) {
    const panel = event.currentTarget.closest('[data-api-demo-target="panel"]')
    const placeholder = panel.querySelector('[data-role="placeholder"]')
    const loading = panel.querySelector('[data-role="loading"]')
    const response = panel.querySelector('[data-role="response"]')
    const button = event.currentTarget
    const label = button.querySelector('span')

    const isShowing = !response.classList.contains('hidden')

    if (isShowing) {
      response.classList.add('hidden')
      response.classList.remove('flex')
      placeholder.classList.remove('hidden')
      label.textContent = 'Send'
      return
    }

    placeholder.classList.add('hidden')
    loading.classList.remove('hidden')
    loading.classList.add('flex', 'flex-col')
    button.disabled = true

    const duration = 200
    const start = performance.now()

    const check = () => {
      if (performance.now() - start >= duration) {
        loading.classList.add('hidden')
        loading.classList.remove('flex', 'flex-col')
        response.classList.remove('hidden')
        response.classList.add('flex')
        label.textContent = 'Clear'
        button.disabled = false
      } else {
        requestAnimationFrame(check)
      }
    }

    requestAnimationFrame(check)
  }
}
